import { IAddStateResponse } from "../../utils/types";
import { apiManager } from "../api-manager";

export const addState = async (body: { name: string; symbol: string }) => {
  const res = await apiManager.post<IAddStateResponse>("/states/addState", {
    state: { ...body },
  });
  return res;
};
